import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Template from '../Components/Template';
import useDataTable from '../Hooks/useDataTable';
import { useDeleteExamFormMutation, useGetAllExamFormsForAdminsMutation, useGetSubAgentsByAgentQuery,useGetAllExamFormsForAdminsFilterMutation, useGetTotalAmountAgentQuery, useGetSchoolsAgentWiseQuery, useGetAllExamFormsForAdminFilterMutation, useGetAllExamFormsOfAgentsForAdminFilterMutation, useGetCashDepositRecordsQuery } from '../Services/modules/exam';
import { MdOutlineNavigateNext, MdSkipNext, MdSkipPrevious, MdEdit, MdDelete } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import WarningModal from '../Components/WarningModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Config } from '../Config';
import { formatDateInput } from '../util/formatDate';
import { useLocation, useParams } from 'react-router-dom';

function ReportAdminOfAgentForms() {
//     const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const agentId = searchParams.get('agentId');
 const { agentId, agentName } = useParams();
console.log("agentId",agentId)
    const userData = useSelector((state) => state.userData.user_data);
   // console.log("Userdata", userData);
   
    let token=userData.token
    const {   
        handleFirstPage,
        handlePageSizeChange,
        handleLastPage,
        sequenceStartIndex,
        page,
        rowsPerPage,
        totalRows,
        setTotalRows,
        setPage,
        setTotalPages,
        totalPages
    } = useDataTable();

    const [examForms, setExamForms] = useState([]);
    const [subAgents, setSubagents] = useState([]);
    const [schoolsAgentWise, setSchoolsAgentWise] = useState([]);
     
    const[total_amount,setTotalAmount]=useState("")
    const [subAgentValue, setSubAgentValue] = useState("");
    const [schoolNameValue, setSchoolNameValue] = useState("");

    const [examNameValue, setExamNameValue] = useState("");
    const [examStandardValue, setExamStandardValue] = useState("");
    const[enrollmentDate,setEnrollmentDate]=useState("")
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    

    const [exam_medium, setExamMedium] = useState("");

    
    const[form_id,setFormId]=useState("")
    const[isDelete,setIsDelete]=useState(false) 
       const[isDeleteModal,setDeleteModal]=useState(false)
            const [cashDepositRecord,setCashDepositRecord]=useState([])
       
    // const { data, isSuccess, isLoading, error, refetch } = useGetAllExamFormsForAdminsQuery({
    //     page_number: page,
    //     page_size: rowsPerPage,
    //     subAgentValue: subAgentValue,
    //     examNameValue: examNameValue,
    //     examStandardValue: examStandardValue
    // });
  const [GetAllExamFormsForAdmin, { data, isSuccess, isLoading, isError, error }] = useGetAllExamFormsOfAgentsForAdminFilterMutation();
const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);

    const { data:depositData, isSuccess:depositSuccess, isLoading:depositIsLoading, error:depositError } = useGetCashDepositRecordsQuery({agentId});
   
  const { data: dataSchools, isSuccess: isSuccessSchools, isLoading: isLoadingSchools, error: errorSchools, refetch: refetchSchools } = useGetSchoolsAgentWiseQuery();

    //const { data: dataSubAgents, isSuccess: isSuccessSubagents, isLoading: isLoadingSubAgents, error: errorSubAgents, refetch: refetchSubagents } = useGetSubAgentsByAgentQuery({ page_number: page, page_size: rowsPerPage });
   // const { data: dataTotalAmount, isSuccess: isSuccessTotalAmount, isLoading: isLoadingTotalAmount, error: errorTotalAmount, refetch: refetchTotalAmount } = useGetTotalAmountAgentQuery({ page_number: page, page_size: rowsPerPage });

    useEffect(()=>{
       if(depositSuccess)
       {
           console.log("deposit data",depositData)
           setCashDepositRecord(depositData?.allRecords)
          // setTotalAmount(data.totalAmount)
       }
    },[depositData])
    const [DeleteExamForm, { 
        data:deleteData=[], 
        isSuccess:deleteIsSuccess, 
        isLoading:deleteIsLoading, 
        isError:deleteIsError, 
        error:deleteError }] = useDeleteExamFormMutation();
    useEffect(() => {
        if (isSuccess) {
            console.log("Exam form data by agents", data);
            setExamForms(data.data);
            setTotalRows(data.totalRows)
            setTotalAmount(data.totalRupees);

        }
    }, [data]);
    

    useEffect(()=>{
        if(isSuccessSchools)
            {
                console.log("DataSchools",dataSchools)
                setSchoolsAgentWise(dataSchools.allSchools)
            }
    },[dataSchools])

    // useEffect(() => {
    //     if (isSuccessSubagents) {
    //         console.log("data of subagents", dataSubAgents);
    //         setSubagents(dataSubAgents.data);
    //     }
    // }, [dataSubAgents, isSuccessSubagents]);

    const applyFilter = () => {
       // refetch();
        GetAllExamFormsForAdmin({
           // page_number: page,
           agentId:agentId,
           page_number: 0,
            page_size: rowsPerPage,
            subAgentValue: subAgentValue,
            exam_name: examNameValue,
            exam_standard: examStandardValue,
            school_name:schoolNameValue,
            fillupby_id:subAgentValue,
          //  enrollment_date:enrollmentDate,
             fromDate:fromDate,
             toDate:toDate,
                    exam_medium:exam_medium
        })
    };

    const handleDelete=(dataRow)=>{
        setDeleteModal(true)
        setFormId(dataRow._id)
      }
      useEffect(() => {
        if(isDelete)
        {
          DeleteExamForm({form_id})
        }
      
      }, [isDelete]);
      useEffect(()=>{
    
        if(deleteIsSuccess)
        {
          console.log("deleteddataProduct",deleteData)
    
          if(!deleteData.error)
          {
            // setProducts(deleteData.data)
            // setTotalRows(deleteData.totalRows)
            toast.success(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)
    
    
    //refetch()
            
          }
          else
          {
            toast.error(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)
    
          }
        
        }
          },[deleteData])

          useEffect(() => {
            console.log("In use Effecttttt")
            GetAllExamFormsForAdmin(
                {
                    agentId:agentId,
                    page_number: page,
                    page_size: rowsPerPage,
                    //subAgentValue: subAgentValue,
                    exam_name: examNameValue,
                    exam_standard: examStandardValue,
                    school_name:schoolNameValue,
                   // fillupby_id:subAgentValue,
                    //enrollment_date:enrollmentDate
                   // form_created_date:form_created_date,
                   fromDate:fromDate,
             toDate:toDate,
                    exam_medium:exam_medium

                }
            );
          }, [page,agentId]);

          const exportToExcel = () => {
            fetch(`${Config.API_URL_LOCAL}exam/getAllExamFormsExcelAdminAgentwiseFilter`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,  // Add the token here
                    // Add any other necessary headers here
                },
                // If your API requires a body, include it here
                 body: JSON.stringify({ 
                    agentId:agentId,
            exam_name: examNameValue,
            exam_standard: examStandardValue,
            school_name:schoolNameValue,                
             fromDate:fromDate,
             toDate:toDate,
            exam_medium:exam_medium,
            enrollmentDate:enrollmentDate
                  }), // Example body
            })
            .then((response) => {
                console.log("response download", response);
                if (!response.ok) {
                    alert("Already Exported")
                    throw new Error('Network response was not ok', response);
                }
                const filename = response.headers.get('X-File-Name') || 'exported-data.xlsx';
                return response.blob().then(blob => ({ filename, blob }));
            })
            .then(({ filename, blob }) => {
                if (blob.size === 0) {
                    throw new Error('Received an empty Excel file');
                }
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                //refetch()
            })
            .catch((error) => console.error('Error exporting to Excel:', error));
        };
         const exportToExcelAgain = () => {
            fetch(`${Config.API_URL_LOCAL}exam/getAllExamFormsExcelAdminAgentwiseFilterExportAgain`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,  // Add the token here
                    // Add any other necessary headers here
                },
                // If your API requires a body, include it here
                 body: JSON.stringify({ 
                    agentId:agentId,
            exam_name: examNameValue,
            exam_standard: examStandardValue,
            school_name:schoolNameValue,                
             fromDate:fromDate,
             toDate:toDate,
            exam_medium:exam_medium,
             enrollmentDate:enrollmentDate
                  }), // Example body
            })
            .then((response) => {
                console.log("response download", response);
                if (!response.ok) {
                    alert("Already Exported")
                    throw new Error('Network response was not ok', response);
                }
                const filename = response.headers.get('X-File-Name') || 'exported-data.xlsx';
                return response.blob().then(blob => ({ filename, blob }));
            })
            .then(({ filename, blob }) => {
                if (blob.size === 0) {
                    throw new Error('Received an empty Excel file');
                }
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                //refetch()
            })
            .catch((error) => console.error('Error exporting to Excel:', error));
        };
const handlePreview = (filePath) => {
  setPreviewFile(filePath);
  setShowPreview(true);
};
    const ReportsScreen = () => {
        return (
            <>
            {showPreview && (
  <div className="modal show d-block" tabIndex="-1" role="dialog" onClick={() => setShowPreview(false)}>
    <div className="modal-dialog modal-lg" role="document" onClick={e => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Proof Preview</h5>
          <button type="button" className="btn-close" onClick={() => setShowPreview(false)}></button>
        </div>
        <div className="modal-body text-center">
          {previewFile.endsWith('.pdf') ? (
            <iframe src={previewFile} title="PDF Preview" width="100%" height="500px"></iframe>
          ) : (
            <img src={previewFile} alt="Preview" style={{ maxWidth: '100%', maxHeight: '500px' }} />
          )}
        </div>
      </div>
    </div>
  </div>
)}
             <
                WarningModal
                setShowWarningModal={setDeleteModal}
                modalTitle={"Delete Product"}
                setIsDelete={setIsDelete}
                showModal={isDeleteModal}
              />
              <ToastContainer/>
                <main id="main" class="main">
                    <div className='container'>
                        <div className="row">
          <h3 className="text-center mb-4">Report of Agent: <strong>{decodeURIComponent(agentName)}</strong></h3>
        </div>
                        <div className='card'>
                            <div className='card-body'>
                                {/* Total Collection: {total_amount} */}
                               
                                <div className='row' style={{ margin: "20px" }}>
                                   
                                    {/* <div className='col-md-3'>
                                        <select
                                            value={subAgentValue}
                                            className='form-control'
                                            onChange={(e) => setSubAgentValue(e.target.value)}
                                        >
                                            <option value="">Select SubAgent</option>
                                            {subAgents.map((eventData) => {
                                                console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData._id} value={eventData._id}>{eventData.full_name}</option>
                                                );
                                            })}
                                        </select>
                                    </div> */}
                                     <div className='col-md-3'>
                                        <select
                                            value={exam_medium}
                                            className='form-control'
                                            onChange={(e) => setExamMedium(e.target.value)}
                                        >
                                            <option value="">Select Medium</option>
                                            <option key="marathi" value="marathi">marathi</option>
                                            <option key="semi" value="semi">semi</option>
                                        </select>
                                    </div>
                                    <div className='col-md-3'>
                                        <select
                                            value={examNameValue}
                                            className='form-control'
                                            onChange={(e) => setExamNameValue(e.target.value)}
                                        >
                                            <option value="">Select Exam</option>
                                            <option key="गुणवत्ता शोध परीक्षा" value="गुणवत्ता शोध परीक्षा">गुणवत्ता शोध परीक्षा</option>
                                            <option key="शताब्दी शिष्यवृत्ती परीक्षा" value="शताब्दी शिष्यवृत्ती परीक्षा">शताब्दी शिष्यवृत्ती परीक्षा</option>
                                        </select>
                                    </div>
                                    <div className='col-md-3'>
                                        <select
                                            value={examStandardValue}
                                            className='form-control'
                                            onChange={(e) => setExamStandardValue(e.target.value)}
                                        >
                                            <option value="">Select Standard</option>
                                            <option key="1" value="1">1</option>
                                            <option key="2" value="2">2</option>
                                            <option key="3" value="3">3</option>
                                            <option key="4" value="4">4</option>
                                            <option key="5" value="5">5</option>
                                            <option key="6" value="6">6</option>
                                            <option key="7" value="7">7</option>
                                            <option key="8" value="8">8</option>
                                        </select>
                                    </div>
                                    <div className='col-md-3'>
                                        <select
                                            value={schoolNameValue}
                                            className='form-control'
                                            onChange={(e) => setSchoolNameValue(e.target.value)}
                                        >
                                            <option value="">Select Schools</option>
                                            {schoolsAgentWise?.map((eventData) => {
                                                console.log("eventData", eventData);
                                                return (
                                                    <option key={eventData.school_name} value={eventData.school_name}>{eventData.school_name}</option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                   
                                </div>
                                <div className='row'  style={{ margin: "20px" }}>
                                    {/* <div className='col-md-3'>
                                    <div className="form-group">
                                  
                                    <input type="text" 
                  className="form-control mb-3" 
                  id="input1"
                  name="form_created_date"
                  placeholder='Form Date'
                  value={form_created_date}
                  onChange={(e) => setFormCreatedDate(e.target.value)}
                   />
                    </div>
                                    </div> */}
                                     <div className='col-md-3'>
    <input
      type="text"
      className="form-control mb-3"
      placeholder="From Date (dd/mm/yyyy)"
      value={fromDate}
      onChange={(e) => setFromDate(formatDateInput(e.target.value))}
      maxLength={10}
    />
  </div>
  <div className='col-md-3'>
    <input
      type="text"
      className="form-control mb-3"
      placeholder="To Date (dd/mm/yyyy)"
      value={toDate}
      onChange={(e) => setToDate(formatDateInput(e.target.value))}
      maxLength={10}
    />
  </div>
                                    <div className='col-md-3'>
                                        <button className='btn btn-primary' onClick={() => applyFilter()}>Apply Filter</button>
                                    </div>
                                     <div className='col-md-3'>
    <input
      type="text"
      className="form-control mb-3"
      placeholder="Enter enrollment date to print (dd/mm/yyyy)"
      value={enrollmentDate}
      onChange={(e) => setEnrollmentDate(formatDateInput(e.target.value))}
      maxLength={10}
    />
    </div>
                                    <div className='col-md-3'>
                                        <button className='btn btn-primary' 
                                        onClick={() => exportToExcel()}>
                                            Export To Excel
                                            </button>
                                    </div>
                                     <div className='col-md-3'>
 <button className='btn btn-primary' 
                                        onClick={() => exportToExcelAgain()}>
                                            Export To Excel Again
                                            </button>
                                     </div>
                                </div>
                                <div className="row" style={{ marginBottom: "20px" }}>
  <div className="col-md-6">
    <div className="card text-white bg-primary mb-3" style={{ maxWidth: '100%' }}>
      <div className="card-header">Total Rupees</div>
      <div className="card-body">
        <h5 className="card-title" style={{color:"#ffffff"}}>{total_amount} ₹</h5>
      </div>
    </div>
  </div>
  <div className="col-md-6">
    <div className="card text-white bg-success mb-3" style={{ maxWidth: '100%' }}>
      <div className="card-header">Total Forms</div>
      <div className="card-body">
        <h5 className="card-title" style={{color:"#ffffff"}}>{totalRows}</h5>
      </div>
    </div>
  </div>
</div>
                                <table className="bordered-table">
                                    <thead>
                                        <tr>
                                        <th>Action</th>
                                          <th>Exported Status</th>
                                            <th>Index</th>
                                             <th>TNumber</th>
                                            <th>Exam</th>
                                            <th>Student</th>
                                            <th>Standard</th>
                                            <th>Phone number</th>
                                            <th>School name</th>
                                            <th>Form Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {examForms.map((item, index) => (
                                            <tr key={index}>

                                                 <td>
                
              <MdDelete onClick={()=>handleDelete(item)} style={{cursor:'pointer'}}/>
              </td>
               <td>
        {item.is_exported ? (
          <span style={{ color: 'green' }}>&#10004;</span> // Green tick for true
        ) : (
          <span style={{ color: 'red' }}>&#10008;</span> // Cross for false
        )}
      </td>
                                                <td>{sequenceStartIndex + index}</td>
                                                 <td>{item.formTNumber}</td>
                                                <td>
                                                    {item.exam_name + " | " + item.exam_fees + " Rs " }
                                                </td>
                                                <td>
                                                    {item.first_name + " " + item.middle_name + " " + item.last_name+"| "+item.gender}
                                                </td>
                                                <td>
                                                    {item.exam_standard+"|"+item.exam_medium}
                                                </td>
                                                {/* <td>
                                                    {item.student_address + " | " + item.student_district + " | " + item.student_taluka + " | " + item.mobile_number}
                                                </td> */}
                                                 <td>
                                                    {/* {item.student_district + " | " + item.student_taluka + " | " + item.mobile_number} */}
                                                    {item.mobile_number}

                                                </td>
                                                <td>
                                                    {/* {item.school_name + " | " + item.school_district + " | " + item.school_taluka + " | " + item.school_area} */}
                                                    {item.school_name }

                                                </td>
                                                <td>
                                                    {item.form_created_date + " " + item.form_created_time}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
      <button onClick={() => handleFirstPage()} disabled={page === 0}><MdSkipPrevious/></button> 

                                <button onClick={() => setPage(page - 1)} disabled={page === 0}><GrFormPrevious /></button>
                                <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1}><MdOutlineNavigateNext /></button>
       <button onClick={() => handleLastPage()} disabled={page === totalPages - 1}><MdSkipNext/></button> 

                                <div>
                                    <select value={rowsPerPage} onChange={handlePageSizeChange}>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        </div>


<div className='card'>
    <div className='card-body'>
        <div className='row' style={{marginTop:"10px"}}>
  <div className="col-md-8">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="mb-3">Submitted Records</h5>
                <table className="table table-bordered">
                 <thead>
  <tr>
    <th>#</th>
    <th>Amount</th>
    <th>Bank</th>
    <th>Acc no</th>
    <th>IFSC</th>
    <th>UTR</th>
    <th>Date</th>
    <th>Proof</th>
    {/* <th>Action</th> */}
  </tr>
</thead>
<tbody>
  {cashDepositRecord.length > 0 ? (
    cashDepositRecord.map((record, index) => (
      <tr key={record._id}>
        <td>{index + 1}</td>
        <td>₹ {record.amount}</td>
        <td>{record.bankName + " | " + record.bankBranch + " | " + record.accType}</td>
        <td>{record.accNo}</td>
        <td>{record.ifsc}</td>
        <td>{record.utrNumber}</td>
        <td>{record.record_created_date}</td>

        {/* Proof Preview Column */}
        <td>
          {record.photoProofFile && (
            <img
              src={`${Config.API_URL_IMAGE}/depositProof/${record.photoProofFile}`}
              alt="Proof"
              style={{ width: '40px', height: '40px', objectFit: 'cover', cursor: 'pointer' }}
              onClick={() => 
                handlePreview(`${Config.API_URL_IMAGE}/depositProof/${record.photoProofFile}`)
            }
            />
          )}
        </td>

        {/* Action Column */}
        {/* <td>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(record)}
            title="Delete"
          >
            🗑️
          </button>
        </td> */}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className="text-center text-muted">No records yet</td>
    </tr>
  )}
</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>


                    </div>
                </main>
            </>
        );
    };

    return (
        <Template>{ReportsScreen()}</Template>
    );
}

export default ReportAdminOfAgentForms;